import { useEffect } from 'react';
import { setDynamicTitle } from '../utils/dynamicTitle';

/**
 * Custom hook to dynamically set the document title based on the current URL
 * Extracts the subdomain from URLs like "apix-test2.apix.co" and formats it as "Apix-Test2 - Apix"
 */
export const useDynamicTitle = () => {
  useEffect(() => {

    // Set title on mount
    setDynamicTitle();

    // Optional: Listen for URL changes (useful for SPAs with client-side routing)
    const handleLocationChange = () => {
      setDynamicTitle();
    };

    // Listen for popstate events (browser back/forward)
    window.addEventListener('popstate', handleLocationChange);

    // Cleanup
    return () => {
      window.removeEventListener('popstate', handleLocationChange);
    };
  }, []);
};

export default useDynamicTitle;
